module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3Snt0"))).then(() => parcelRequire('ljYL6'));